import React, { FC, useState, useRef } from "react";
import styles from "./contactForm.module.scss";
import { ContactFormData } from "../../../models/registrationModel";
import { useMutation } from "react-query";
import contactUsService from "../../../service/contactUs/contactUs";
import MsgModal from "../../../componsnts/common/customModal/customModal";

const ContactForm: FC = () => {
  const [isMsgModalOpen, setIsMsgModalOpen] = useState(false);
  const [modalMessageOpen, setModalMessageOpen] = useState('');
  const [contactFormData, setContactFormData] = useState<ContactFormData>({
    Name: "",
    Company: "",
    JobTitle: "",
    Phone: "",
    Email: "",
    Content: ""
  });
  const [errorMessage, setErrorMessage] = useState({
    Email: "",
    ContacterPhone: "",
  });

  const resetFormdata = () => {
    setContactFormData({
      Name: "",
      Company: "",
      JobTitle: "",
      Phone: "",
      Email: "",
      Content: ""
    })
  }

  const mesModal = (msg: string) => {
    setIsMsgModalOpen(true)
    setModalMessageOpen(msg)
  }

  const closeModal = () => {
    setIsMsgModalOpen(false);
  };

  const [errors, setErrors] = useState<{ [key: string]: boolean }>({});
  const inputChanged = useRef(false);

  // {正則判斷} ~~~~~
  const telephone = /^0\d{8,9}$/;
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    inputChanged.current = true;
    setContactFormData({
      ...contactFormData,
      [e.target.name]: e.target.value,
    });
  };

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    const {
      Email,
      Phone,
    } = contactFormData;


    let hasErrors = false;

    if (!emailPattern.test(Email)) {
      setErrorMessage(prevErrorMessages => ({
        ...prevErrorMessages,
        Email: "信箱格式錯誤",
      }));
      setErrors(prevErrors => ({
        ...prevErrors,
        Email: true,
      }));
      hasErrors = true;
    }




    const emptyFields = Object.entries(contactFormData).reduce<{ [key: string]: boolean }>((acc, [key, value]) => {
      if (value.trim() === "") {
        acc[key] = true;
      }
      return acc;

    }, {});

    if (hasErrors || Object.keys(emptyFields).length > 0) {
      setErrors(prevErrors => ({
        ...prevErrors,
        ...emptyFields,
      }));
      return;
    }


    setErrors({});
    contactUsSubmit(contactFormData)
  };

  const {
    mutate: contactUsSubmit,
  } = useMutation({
    mutationFn: (data: ContactFormData) => contactUsService.contactUs(data),
    onSuccess: (res) => {
      mesModal('已送出表單')
      resetFormdata();
    },
    onError: (err) => {
      mesModal(`表單送出失敗${err}`)
    },
  });

  const getInputStyle = (field: string) => {
    if (errors[field]) {
      return { border: '1px solid red', color: 'red' };
    } else {
      return {};
    }
  };


  const handleFocus = (field: string) => {
    setErrors((prevErrors) => ({
      ...prevErrors,
      [field]: false,
    }));
  };

  const handleBlur = (field: string, value: string) => {
    if (!inputChanged.current) {
      return
    }
    if (value.trim() === "") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [field]: true,
      }));
    }
  };

  return (
    <>
      <MsgModal isOpen={isMsgModalOpen} onClose={closeModal} message={modalMessageOpen}></MsgModal>
      <div className={styles["contactForm_container"]}>
        <form onSubmit={onSubmit} className="form_box">
          <div className="formTitle">請填寫以下表格，我們將盡快與您聯繫</div>
          <div className="form_body">
            <div className="input_container">
              <div className="input_row">
                <div className="input_box">
                  <div className="title_box">
                    <img
                      className="icons"
                      src="/assets/images/modal/user.svg"
                      alt=""
                    />
                    <div className="input_title">聯絡人姓名</div>
                    <div className="redText">*</div>
                  </div>
                  <input
                    id="Name"
                    name="Name"
                    value={contactFormData.Name}
                    onChange={handleChange}
                    onFocus={() => handleFocus('Name')}
                    onBlur={() => handleBlur('Name', contactFormData.Name)}
                    type="text"
                    className="contact_input"
                    style={getInputStyle('Name')}
                    placeholder="請輸入您的姓名"
                  />
                </div>

                <div className="input_box">
                  <div className="title_box">
                    <img
                      className="icons"
                      src="/assets/images/modal/building.svg"
                      alt=""
                    />
                    <div className="input_title">公司名稱</div>
                    <div className="redText">*</div>
                  </div>
                  <input
                    id="Company"
                    name="Company"
                    value={contactFormData.Company}
                    onChange={handleChange}
                    onFocus={() => handleFocus('Company')}
                    onBlur={() => handleBlur('Company', contactFormData.Company)}
                    type="text"
                    className="contact_input"
                    style={getInputStyle('Company')}
                    placeholder="請輸入您的公司名稱"
                  />
                </div>
              </div>

              <div className="input_row">
                <div className="input_box">
                  <div className="title_box">
                    <img
                      className="icons"
                      src="/assets/images/modal/userTitle.png"
                      alt=""
                    />
                    <div className="input_title">聯絡人職稱</div>
                    <div className="redText">*</div>
                  </div>
                  <input
                    id="JobTitle"
                    name="JobTitle"
                    value={contactFormData.JobTitle}
                    onChange={handleChange}
                    onFocus={() => handleFocus('JobTitle')}
                    onBlur={() => handleBlur('JobTitle', contactFormData.JobTitle)}
                    type="text"
                    className="contact_input"
                    style={getInputStyle('JobTitle')}
                    placeholder="請輸入您的職稱"
                  />
                </div>

                <div className="input_box">
                  <div className="title_box">
                    <img
                      className="icons"
                      src="/assets/images/modal/phone.svg"
                      alt=""
                    />
                    <div className="input_title">聯絡電話</div>
                    <div className="redText">*</div>
                    {errorMessage.ContacterPhone && <span className="error_message">{errorMessage.ContacterPhone}</span>}
                  </div>
                  <input
                    id="Phone"
                    name="Phone"
                    value={contactFormData.Phone}
                    onChange={handleChange}
                    onFocus={() => handleFocus('Phone')}
                    onBlur={() => handleBlur('Phone', contactFormData.Phone)}
                    type="text"
                    className="contact_input"
                    style={getInputStyle('Phone')}
                    placeholder="請輸入您的電話"
                  />
                </div>
              </div>

              <div className="input_row">
                <div className="input_box fluid">
                  <div className="title_box">
                    <img
                      className="icons"
                      src="/assets/images/modal/email.svg"
                      alt=""
                    />
                    <div className="input_title">聯絡人信箱</div>
                    <div className="redText">*</div>
                    {errorMessage.Email && <span className="error_message">{errorMessage.Email}</span>}
                  </div>
                  <input
                    id="Email"
                    name="Email"
                    value={contactFormData.Email}
                    onChange={handleChange}
                    onFocus={() => handleFocus('Email')}
                    onBlur={() => handleBlur('Email', contactFormData.Email)}
                    type="text"
                    className="contact_input"
                    style={getInputStyle('Email')}
                    placeholder="請輸入您的信箱"
                  />
                </div>
              </div>

              <div className="input_row">
                <div className="input_box fluid">
                  <div className="title_box">
                    <img
                      className="icons"
                      src="/assets/images/modal/needs.png"
                      alt=""
                    />
                    <div className="input_title">需求內容</div>
                    <div className="redText">*</div>
                  </div>
                  <textarea
                    id="Content"
                    name="Content"
                    value={contactFormData.Content}
                    onChange={handleChange}
                    onFocus={() => handleFocus('Content')}
                    onBlur={() => handleBlur('Content', contactFormData.Content)}
                    className="contact_input textArea"
                    style={getInputStyle('Content')}
                    placeholder="請留言寫您的需求"
                  />
                </div>
              </div>

              <div className="button_box">
                <button className="submitBtn" type="submit">確認送出</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default ContactForm;